import { SalesWizardLayout } from '@/layouts';
import { GetStarted, SalesWizard, SignupSuccess, StripePaymentRedirect } from '@/views';
import { EmailConfirmationPage } from '@/views/Confirmation';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
export const AppRoutes = () => {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "/" },
            React.createElement(Route, { path: "/", element: React.createElement(GetStarted, null) }),
            React.createElement(Route, { path: "/emailconfirmation", element: React.createElement(EmailConfirmationPage, null) })),
        React.createElement(Route, { path: "/", element: React.createElement(SalesWizardLayout, null) },
            React.createElement(Route, { path: "/salesWizard", element: React.createElement(SalesWizard, null) }),
            React.createElement(Route, { path: "/paymentRedirect", element: React.createElement(StripePaymentRedirect, null) }),
            React.createElement(Route, { path: "/signupSuccess", element: React.createElement(SignupSuccess, null) }))));
};
